import { QuestionsCount } from "../../types/Events";

export const calculateQuestionCount = (questionCount: QuestionsCount): number =>
  questionCount.retail + questionCount.institutional + questionCount.analyst;
